import {mapActions, mapState} from 'vuex'
import moment from 'moment'
import insuranceRecordChild from './insurance-record-child'
export default {
  data () {
    return {
      activeName: 'first',
      pageSize: 6
    }
  },
  components: {
    insuranceRecordChild: insuranceRecordChild
  },
  computed: {
    ...mapState('wxMemberModule', ['myItemDataList', 'myItemTotalRecord']),
    myItemData () {
      return this.myItemDataList
    }
  },
  methods: {
    ...mapActions('wxMemberModule', ['getFinancialProjectInstance']),
    pageSizeChange () {
      if (this.myItemDataList.length === this.myItemTotalRecord) {
        this.$message.warning('无更多数据')
        return
      }
      this.pageSize = this.pageSize + 6
      let state = 1000
      if (this.activeName === 'first') {
        state = 1000
      } else if (this.activeName === 'second') {
        state = 2000
      } else {
        state = 3000
      }
      this.searchInfoByCondition(state)
    },
    searchInfoByCondition (state) {
      let data = {
        pageNum: 1,
        pageSize: this.pageSize,
        pageSort: 'id',
        pageOrder: 'desc',
        status: state
      }
      this.getFinancialProjectInstance(data)
    },
    handleClick (tab, event) {
      let state = 1000
      if (tab.name === 'first') {
        state = 1000
      } else if (tab.name === 'second') {
        state = 2000
      } else {
        state = 3000
      }
      this.pageSize = 6
      this.searchInfoByCondition(state)
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    }
  },
  mounted () {
    this.searchInfoByCondition(1000)
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/views/components/my-insurance-record.js